import { FaImages } from "react-icons/fa";
import { numberWithDotAndCommas } from "../../../../../../../utils/numberWithDotAndComas";
import Image from "../../../../../../common/image/Image";
import { COLORS, Typo } from "../../../../../../layout/theme";
import { AntdTable, Container, Section, TableContainer } from "./styles";
import CustomAntdTooltip from "../../../../../../common/custom-antd-tooltip/CustomAntdTooltip";
import { InfoCircleOutlined } from "@ant-design/icons";

export default function OrderTable({ data }) {
	const columns = [
		{
			title: () => (
				<div style={{ color: COLORS.White, fontWeight: 700 }}>PRODUCTO</div>
			),
			dataIndex: "productTitle",
			render: (value, record) => (
				<div style={{ display: "flex", gap: 20 }}>
					<Image
						width={40}
						height={40}
						src={record.productPhotoUrl}
						alt={record.productTitle}
					/>
					<Section>
						<div style={{ display: "flex", gap: 10 }}>
							<Typo type="primary" fontWeight={600} fontSize={14}>
								{value}
							</Typo>
							{record.productComboName && (
								<CustomAntdTooltip
									width="250px"
									tooltipContent={[
										{
											title: "Producto de combo",
											body: `Este producto proviene del combo ${record.productComboName}`,
										},
									]}
								>
									<InfoCircleOutlined
										style={{ color: COLORS.Warning, cursor: "pointer" }}
									/>
								</CustomAntdTooltip>
							)}
						</div>
						<Typo type="mediumGrey" fontWeight={600} fontSize={10}>
							EAN: {record.productEan13}
						</Typo>
					</Section>
				</div>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.White, fontWeight: 700 }}>LABORATORIO</div>
			),
			dataIndex: "productClient",
			width: 140,
			render: (value) => (
				<Typo type="darkGrey" fontWeight={600} fontSize={14}>
					{value}
				</Typo>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.White, fontWeight: 700 }}>MARCA</div>
			),
			dataIndex: "productBrand",
			width: 130,
			render: (value, record) => (
				<Section>
					<Typo type="darkGrey" fontWeight={600} fontSize={14}>
						{value}
					</Typo>
					{/* <Typo type="mediumGrey" fontWeight={600} fontSize={12}>
						({record.productClient})
					</Typo> */}
				</Section>
			),
		},
		// {
		// 	title: () => (
		// 		<div style={{ color: COLORS.White, fontWeight: 700 }}>PRECIO</div>
		// 	),
		// 	dataIndex: "productPrice",
		// 	render: (value) => (
		// 		<Typo type="darkGrey" fontWeight={600} fontSize={14}>
		// 			${numberWithDotAndCommas(value)}
		// 		</Typo>
		// 	),
		// },
		{
			title: () => (
				<div
					style={{
						color: COLORS.White,
						fontWeight: 700,
						textAlign: "center",
					}}
				>
					DESC.
				</div>
			),
			dataIndex: "productOfferPrice",
			width: 100,
			render: (value, record) => (
				<div
					style={{
						textAlign: "center",
					}}
				>
					<Typo type="success" fontWeight={700} fontSize={14}>
						{`${numberWithDotAndCommas(
							(
								100 -
								(record.productOfferPrice * 100) / record.productPrice
							).toFixed(2),
						)}%`}
					</Typo>
				</div>
			),
		},
		{
			title: () => (
				<div
					style={{
						color: COLORS.White,
						fontWeight: 700,
						textAlign: "center",
					}}
				>
					CANTIDAD
				</div>
			),
			dataIndex: "productQuantity",
			width: 110,
			render: (value) => (
				<div
					style={{
						textAlign: "center",
					}}
				>
					<Typo type="darkGrey" fontWeight={600} fontSize={14}>
						{value}
					</Typo>
				</div>
			),
		},
		{
			title: () => (
				<div
					style={{
						color: COLORS.White,
						fontWeight: 700,
						textAlign: "end",
					}}
				>
					FINAL
				</div>
			),
			dataIndex: "productOfferPrice",
			width: 200,
			render: (value, r) => (
				<Section style={{ alignItems: "end" }}>
					<Typo type="primary" fontWeight={700} fontSize={14}>
						${numberWithDotAndCommas((value * r.productQuantity).toFixed(2))}
					</Typo>
				</Section>
			),
		},
		{
			title: () => (
				<div
					style={{
						color: COLORS.White,
						fontWeight: 700,
						textAlign: "center",
					}}
				>
					FACTURADAS
				</div>
			),
			dataIndex: "productUnitsBilled",
			width: 130,
			render: (value, r) => (
				<div
					style={{
						textAlign: "center",
					}}
				>
					{value === 0 &&
					r.productUnitsPending === 0 &&
					r.productUnitsTRF === 0 ? (
						<Typo type="mediumGrey" fontWeight={600} fontSize={12}>
							Sin Inf.
						</Typo>
					) : (
						<Typo type="darkGrey" fontWeight={600} fontSize={14}>
							{value}
						</Typo>
					)}
				</div>
			),
		},
		{
			title: () => (
				<div
					style={{
						color: COLORS.White,
						fontWeight: 700,
						textAlign: "center",
					}}
				>
					PENDIENTES
				</div>
			),
			dataIndex: "productUnitsPending",
			width: 120,
			render: (value, r) => (
				<div
					style={{
						textAlign: "center",
					}}
				>
					{value === 0 &&
					r.productUnitsBilled === 0 &&
					r.productUnitsTRF === 0 ? (
						<Typo type="mediumGrey" fontWeight={600} fontSize={12}>
							Sin Inf.
						</Typo>
					) : (
						<Typo type="darkGrey" fontWeight={600} fontSize={14}>
							{value}
						</Typo>
					)}
				</div>
			),
		},
		// {
		// 	title: () => <div style={{ color: COLORS.White }}>Estado</div>,
		// 	dataIndex: "productStateInOrder",
		// 	className: "statusColumn",
		// 	render: (value, r) =>
		// 		value === "FACTURADO" ? (
		// 			<Typo type="success" fontWeight={600} fontSize={14}>
		// 				{value}
		// 			</Typo>
		// 		) : (
		// 			<Typo type="muted" fontWeight={600} fontSize={14}>
		// 				{value}
		// 			</Typo>
		// 		),
		// },
	];

	return (
		<TableContainer>
			<AntdTable
				columns={columns}
				dataSource={data.items}
				pagination={false}
				scroll={{
					y: 450,
				}}
			/>
		</TableContainer>
	);
}
